<template>
  <section class="workspace-navbar">
    <div class="workspace-navbar__main">
      <div class="workspace-navbar__left">
        <button
          class="workspace-navbar__toggle"
          type="button"
          :aria-label="sidebar.opened ? '收起侧栏' : '展开侧栏'"
          @click="toggleSideBar"
        >
          <i :class="sidebar.opened ? 'el-icon-s-fold' : 'el-icon-s-unfold'"></i>
        </button>

        <div class="workspace-navbar__titles">
          <div class="workspace-navbar__headline">
            <h1>{{ pageTitle }}</h1>
          </div>
          <breadcrumb v-if="showBreadcrumb"></breadcrumb>
        </div>
      </div>

      <div class="workspace-navbar__right">
        <a class="workspace-navbar__shortcut workspace-navbar__shortcut--ghost" href="/marketplace">
          返回商店
        </a>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import Breadcrumb from '@/components/Breadcrumb';

export default {
  components: {
    Breadcrumb
  },
  computed: {
    ...mapGetters(['sidebar']),
    breadcrumbList() {
      return this.$route.matched.filter((item) => {
        return item.meta && item.meta.title;
      });
    },
    pageTitle() {
      const current = this.breadcrumbList[this.breadcrumbList.length - 1];
      return (current && current.meta && current.meta.title) || '控制台';
    },
    showBreadcrumb() {
      return this.breadcrumbList.length > 1;
    }
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('ToggleSideBar');
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.workspace-navbar {
  position: sticky;
  top: calc(var(--shell-header-height, 88px) + 20px);
  z-index: 20;
  margin-bottom: 18px;
}

.workspace-navbar__main {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 16px 18px;
  border: 1px solid var(--shell-border, rgba(129, 150, 178, 0.18));
  border-radius: 22px;
  background: rgba(255, 255, 255, 0.72);
  backdrop-filter: blur(16px);
  box-shadow: var(--shell-soft-shadow, 0 24px 60px rgba(28, 46, 76, 0.12));
}

.workspace-navbar__left {
  display: flex;
  align-items: center;
  gap: 14px;
  min-width: 0;
}

.workspace-navbar__toggle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  border: 0;
  border-radius: 14px;
  background: linear-gradient(180deg, #ffffff 0%, #eef3f8 100%);
  box-shadow: inset 0 0 0 1px rgba(140, 160, 186, 0.2);
  color: var(--shell-text-primary, #1d2b3d);
  font-size: 16px;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.workspace-navbar__toggle:hover {
  transform: translateY(-1px);
  box-shadow: inset 0 0 0 1px rgba(72, 105, 145, 0.24),
    0 14px 30px rgba(37, 58, 92, 0.12);
}

.workspace-navbar__titles {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.workspace-navbar__headline {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.workspace-navbar__headline h1 {
  margin: 0;
  color: var(--shell-text-primary, #1d2b3d);
  font-size: 22px;
  line-height: 1.2;
  font-weight: 700;
}

.workspace-navbar__right {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.workspace-navbar__shortcut {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  padding: 0 14px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.72);
  color: #355272;
  font-size: 13px;
  font-weight: 600;
  box-shadow: inset 0 0 0 1px rgba(140, 160, 186, 0.22);
}

.workspace-navbar__shortcut--ghost {
  background: rgba(255, 255, 255, 0.72);
}

@media (max-width: 1080px) {
  .workspace-navbar__main {
    align-items: flex-start;
    flex-direction: column;
  }

  .workspace-navbar__right {
    width: 100%;
    justify-content: flex-start;
  }
}

@media (max-width: 768px) {
  .workspace-navbar {
    top: calc(var(--shell-header-height, 88px) + 16px);
    margin-bottom: 18px;
  }

  .workspace-navbar__main {
    padding: 16px;
    border-radius: 20px;
  }

  .workspace-navbar__headline h1 {
    font-size: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue